import { render, staticRenderFns } from "./signin.vue?vue&type=template&id=505d6f42&scoped=true"
import script from "./signin.vue?vue&type=script&lang=js"
export * from "./signin.vue?vue&type=script&lang=js"
import style0 from "./signin.vue?vue&type=style&index=0&id=505d6f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d6f42",
  null
  
)

export default component.exports